import PaymentRadio from './PaymentRadio';

export default PaymentRadio;
